<template>
  <div>
    <b-table-simple borderless>
      <b-thead>
        <b-tr>
          <b-th>Questionnaires</b-th>
          <b-th>Requested Date</b-th>
          <b-th>Completed Date</b-th>
          <b-th>Status & Link</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(data,index) in questionnairesData" :key="index">
          <b-td>{{data.title}}</b-td>
          <b-td>{{data.requested_at}}</b-td>
          <b-td>{{data.completed_at}}</b-td>
          <b-td>
            <p v-if="data.url != ''" @click="openUrl(data)">
              <span class="text-primary">
                <u>Completed</u>
              </span>
            </p>
            <p v-else>
              <span class="text-primary">
                <u>Not Started</u>
              </span>
            </p>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>
<script>
export default {
  name: "QuestionnairesComponent",
  data() {
    return {};
  },
  methods: {
    openUrl(data) {
      let urlAddress = process.env.VUE_APP_BASE_URL + "/" + data.url;
      window.open(urlAddress);
    }
  },
  props: {
    questionnairesData: Array
  }
};
</script>